import styled from "styled-components";

export const Section = styled.section`
	padding: 4rem 0;
	background-color: #fff;

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1rem;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	gap: 2.5rem;

	@media (min-width: 992px) {
		flex-direction: row;
		gap: 4rem;
	}
`;

export const TextSide = styled.div`
	flex: 1;

	.label {
		color: #642b73;
		font-weight: 600;
		font-size: 0.85rem;
		text-transform: uppercase;
		letter-spacing: 0.05em;
	}

	h2 {
		font-size: 2rem;
		font-weight: 700;
		color: #1a1a2e;
		margin-top: 0.5rem;
		margin-bottom: 0.75rem;

		@media (min-width: 768px) {
			font-size: 2.5rem;
		}
	}

	> p {
		color: #6b7280;
		line-height: 1.6;
		font-size: 1rem;
	}
`;

export const ImageSide = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;

	img {
		width: 16rem;

		@media (min-width: 576px) {
			width: 20rem;
		}

		@media (min-width: 992px) {
			width: 100%;
			max-width: 400px;
		}
	}
`;

export const FeatureList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 1.5rem 0;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const FeatureItem = styled.li`
	display: flex;
	align-items: center;
	gap: 0.75rem;

	span {
		font-size: 0.95rem;
		font-weight: 500;
		color: #1a1a2e;
	}
`;

export const FeatureIcon = styled.div`
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 0.5rem;
	background-color: rgba(100, 43, 115, 0.1);
	color: #642b73;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	gap: 0.75rem;
	flex-wrap: wrap;
`;

export const ActionButton = styled.button`
	padding: 0.75rem 1.5rem;
	border-radius: 0.5rem;
	font-size: 0.95rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;
	border: 2px solid #642b73;

	${(props) =>
		props.$variant === "outline"
			? `
		background-color: transparent;
		color: #642b73;

		&:hover {
			background-color: rgba(100, 43, 115, 0.05);
		}
	`
			: `
		background-color: #642b73;
		color: #fff;

		&:hover {
			background-color: #7a3590;
		}
	`}
`;
